export default "__VITE_ASSET__DQft6B_r__"